@if (status === 'OPEN') {
  <div class="sidebar p-3 ms-4">
    <div class="d-flex align-items-center">
      <div class="flex-grow-1">
        @if (view === CalculationFormSidebarViewEnum.TableOfContents) {
          <div class="btn-group">
            <button aria-expanded="false" class="btn btn-link dropdown-toggle" data-bs-toggle="dropdown"
              type="button">
              Table des matières
              @if (badgeCount !== 0) {
                <span
                class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle"></span>
              }
            </button>
            <ul class="dropdown-menu">
              <li>
                <button (click)="navigateTo(CalculationFormSidebarViewEnum.Errors)" class="dropdown-item">
                  Erreurs
                  @if (badgeCount !== 0) {
                    <span
                    class="badge text-bg-danger">{{ badgeCount }}</span>
                  }
                </button>
              </li>
            </ul>
          </div>
        }
        @if (view === CalculationFormSidebarViewEnum.Errors) {
          <div class="btn-group">
            <button aria-expanded="false" class="btn btn-link dropdown-toggle" data-bs-toggle="dropdown"
              type="button">
              Erreurs
              @if (badgeCount !== 0) {
                <span
                class="badge text-bg-danger">{{ badgeCount }}</span>
              }
            </button>
            <ul class="dropdown-menu">
              <li>
                <button (click)="navigateTo(CalculationFormSidebarViewEnum.TableOfContents)"
                  class="dropdown-item">
                  Table des matières
                </button>
              </li>
            </ul>
          </div>
        }
      </div>
      <button (click)="closeSidebar()" class="btn btn-link"><i class="fa fa-times"></i></button>
    </div>
    @if (view === CalculationFormSidebarViewEnum.TableOfContents) {
      <div>
        @for (heading of headings; track heading) {
          <app-calculation-form-sidebar-heading
          [heading]="heading"></app-calculation-form-sidebar-heading>
        }
      </div>
    }
    @if (view === CalculationFormSidebarViewEnum.Errors) {
      <div>
        @if (errors.length === 0) {
          <p class="text-gray-600">Aucune erreur</p>
        }
        <div class="list-group">
          @for (error of errors; track error) {
            <a (click)="highlightTarget(error.property + '_group')"
              [fragment]="error.property + '_group'" class="list-group-item list-group-item-action"
              routerLink=".">
              <h4>{{ getLabelTitle(error.property) }}</h4>
              @if (showPropertyPath) {
                <div>
                  <small class="bg-secondary p-2 badge rounded-pill">Path: {{ error.property }}</small>
                  <small class="bg-primary p-2 badge rounded-pill">Value: {{ error.value }}</small>
                </div>
              }
              <ul class="mb-0">
                @for (message of error.messages; track message) {
                  <li class="text-danger">{{ message }}</li>
                }
              </ul>
            </a>
          }
        </div>
      </div>
    }
  </div>
}

@if (status === 'CLOSED') {
  <button (click)="openSidebar()" class="btn btn-light me-3" id="floating-sidebar-button"><i
  class="fas fa-columns"></i></button>
}
